import React from "react";
import { Flex, Tag, Table, TableBody, TableCell, TableHeader, TableRow } from "@jsq/ds/core";
import * as styles from "./styles_vanilla.css";
import type { AccountsTableProps } from "./interfaces";

export const AccountsTable = ({ accounts, updatedPositionsPerAccount }: AccountsTableProps) => {
  const showChanges = !!updatedPositionsPerAccount;

  return (
    <Table>
      <TableHeader>
        <TableRow>
          <TableCell header>Investment account</TableCell>
          <TableCell header>Manager</TableCell>
          <TableCell header>Investment</TableCell>
        </TableRow>
      </TableHeader>
      {/* @ts-expect-error - TODO: fix this */}
      <TableBody>
        {accounts.map((account) => {
          const {
            node: { positions },
          } = account;

          if (!positions?.edges.length) {
            return null;
          }

          return (
            <TableRow key={account.node.id} data-cy="summary-row">
              <TableCell className={styles.investmentAccountCell}>
                {account.node.name}
              </TableCell>
              <TableCell className={styles.managerCell}>
                {account.node.gpDisplayName || account.node.arena?.name}
              </TableCell>
              <TableCell>
                {positions.edges.map((position) => {
                  const updatedPositionIds = new Set(
                    updatedPositionsPerAccount?.[account.node.id] ?? [],
                  );
                  return (
                    <Flex key={position.node.id} className="stacked-sm">
                      <Flex flexGrow={1}>{position.node.investmentEntity.name}</Flex>
                      {showChanges && (
                        <Flex
                          flexShrink={0}
                          className={styles.statusWrapper}
                          alignItems="flex-start"
                        >
                          {updatedPositionIds.has(position.node.id) ? (
                            <Tag variant="success">Updated</Tag>
                          ) : (
                            <Tag variant="neutral">Not Updated</Tag>
                          )}
                        </Flex>
                      )}
                    </Flex>
                  );
                })}
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};

export default AccountsTable;
